import { useEffect, useState } from 'react';
import {
  GET_DRAFT_CURRENCIES,
  GET_USER_CURRENCIES
} from '../constants/aryGraphqlSchemas';
import { useAryLazyQuery } from './useAryGraphql';

function useCurrencyDecimalPlacesDeprecated(
  currencyCode,
  branchId,
  ifGetDraftCurrency = false
) {
  const [decimalPlaces, setDecimalPlaces] = useState();

  const [getCurrencies, { data }] = useAryLazyQuery({
    gqlConfig: ifGetDraftCurrency ? GET_DRAFT_CURRENCIES : GET_USER_CURRENCIES,
    items: `
      code
      decimalPlaces
    `
  });

  useEffect(() => {
    if (ifGetDraftCurrency) {
      getCurrencies(branchId);
    } else {
      getCurrencies();
    }
  }, [ifGetDraftCurrency]);

  useEffect(() => {
    if (currencyCode && data) {
      const desiredCurrency =
        data?.find((currency) => currency.code === currencyCode) || '';
      setDecimalPlaces(desiredCurrency?.decimalPlaces);
    }
  }, [currencyCode, data]);

  return decimalPlaces;
}

export default useCurrencyDecimalPlacesDeprecated;
